// Volto customization entrypoint for `@eeacms/volto-pdf-block` BlockView.
//
// We redirect the addon BlockView to our local TypeScript implementation at:
// `src/components/PDFViewer/BlockView.tsx`.

import BlockView from '../../../../../../components/PDFViewer/BlockView';

export default BlockView;
